import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyQrCodeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyQrCodeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyQrCode = (request: VerifyQrCodeRequest, options?: CashRequestOptions) =>
  post<VerifyQrCodeRequest, VerifyQrCodeResponse>('/2.0/cash/verify-qr-code', request, {
    ...options,
    rejectOnError: true,
  })
